var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:{'ribbon__wrapper--vwa': _vm.props.type === 'vwa'}},[_c('div',{staticClass:"ribbon__content pl-1",class:{'ribbon__content--vwa': _vm.props.type === 'vwa'},style:({
      backgroundColor: ("var(--" + (_vm.props.backgroundcolorRibbon) + ")"),
      color: ("var(--" + (_vm.props.colorRibbon) + ")")
    }),attrs:{"aria-label":_vm.props.contentLabel}},[_vm._v(" "+_vm._s(_vm.props.contentLabel)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }